export default __webpack_public_path__ + "static/media/regulatory--priority-road--g2.922fe884.png";